@if (table$(); as table) {
  <div class="sol-table" role="grid" [style]="tableStyle$()">
    <div class="sol-table-header-row" role="row">
      <div class="sol-table-header-container"></div>
      @for (column of table.columns; track column.definition.id) {
        <div class="sol-table-header-container">
          <div class="sol-table-header-cell" role="columnheader">
            <div class="sol-table-header-cell-value">
              @if (column.definition.nameTranslatable) {
                {{ column.definition.name || '' | translate }}
              } @else {
                {{ column.definition.name || '' }}
              }
            </div>
          </div>
        </div>
      }
    </div>

    @for (group of table.visibleGroups; track group.id) {
      @if (group.rows.length > 0) {
        <div class="sol-table-group" role="rowgroup">
          @if (group.name) {
            <div class="sol-table-group-header">{{ group.name }}</div>
          }
          @for (row of group.rows; track row.id) {
            <div class="sol-table-row" role="row" [attr.data-row-id]="row.id">
              <div class="sol-table-cell sol-table-cell-value-spacer" role="gridcell"></div>
              @for (cell of row.cells; track cell.id) {
                <div class="sol-table-cell" role="gridcell">
                  @if (cell.isPrimitive) {
                    @if (
                      cell.type.isA(SolType.string) ||
                      cell.type.isA(SolType.text) ||
                      cell.type.isA(SolType.number) ||
                      cell.type.isA(SolType.date)
                    ) {
                      <div
                        [class]="'sol-table-cell-value-text' + (cell.color ? ' sol-text-color-' + cell.color : '')"
                        [class.sol-table-cell-value-text-truncated]="cell.truncated ?? false"
                      >
                        @if (cell.type.isA(SolType.date)) {
                          {{ cell.value | date: cell.format ?? 'shortDate' }}
                        } @else if (cell.type.isA(SolType.text)) {
                          {{ cell.value | translate }}
                        } @else {
                          {{ cell.value }}
                        }
                      </div>
                    } @else if (cell.type.isA(SolType.icon)) {
                      <div class="sol-table-cell-value-icon">
                        @if (cell.type.isArray) {
                          @for (icon of cell.value; track idx; let idx = $index) {
                            <sol-icon [name]="icon" />
                          }
                        } @else {
                          <sol-icon [name]="cell.value" />
                        }
                      </div>
                    }
                  } @else {
                    <div class="sol-table-cell-value">
                      <sol-view [data]="cell.viewData!" />
                    </div>
                  }
                </div>
              }
            </div>
          }
        </div>
      }
    }
  </div>

  @if (summary$(); as summary) {
    <div class="sol-paginator sol-table-report-summary">
      <div class="sol-paginator-total">{{ summary | translate }}</div>
    </div>
  }
}
